import { HomePage } from './pages/home-page';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Whatsapp } from './cmps/whatsapp';
import { Header } from './cmps/header';
import { SiteSettingsProvider } from './contexts/SiteSettingsContext';

export function RootCmp() {
  return (
    <SiteSettingsProvider>
      <Router>
        <Header />
        <Routes>
          <Route path='/' element={<HomePage />} />
        </Routes>
        <Whatsapp />
      </Router>
    </SiteSettingsProvider>
  )
}

export default RootCmp